import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { Source } from '@store';
import { withLinks } from '@utilities';

type Props = {
	data: Source;
	className: string;
};

const StaticSourceDetails: FC<Readonly<Props>> = ({ data, className }) => {
	const { t } = useTranslation();

	return (
		<div className={className} data-testid="table-static-details">
			{data.notes_dmarc && (
				<section>
					<h4>{t('Description')}</h4>

					<p // nosemgrep: eslint.react-dangerouslysetinnerhtml
						dangerouslySetInnerHTML={{ __html: withLinks(data.notes_dmarc) }}
					/>
				</section>
			)}

			{data.static_source_notes && (
				<section>
					<h4>{t('Possible Action')}</h4>

					<p // nosemgrep: eslint.react-dangerouslysetinnerhtml
						dangerouslySetInnerHTML={{ __html: withLinks(data.static_source_notes) }}
					/>
				</section>
			)}
		</div>
	);
};

export default StaticSourceDetails;
